import { BackTop, Layout } from 'antd'
import React, { useState, useEffect, Suspense } from 'react'
import { Route, Routes, useLocation, Outlet } from 'react-router-dom'
import { useSession } from '@slerp/accounts'
import Loading from 'components/Utils/Loading'
import LayoutContent from './LayoutContent'
import Sidebar from './Sidebar'
import LayoutTitle from './LayoutTitle'
import styled from '@emotion/styled'
import { COLLAPSED_MARGIN_LEFT, EXPANDED_MARGIN_LEFT } from './constants'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import PrintOrder from 'components/Orders/PrintOrder'

export interface PageHeaderType {
  title: string
  tooltipTitle?: React.ReactElement<any> | string
}

const StaffContainer = () => {
  const { user } = useSession()
  const location = useLocation()
  const [pathContext] = location?.pathname?.split('/').slice(1, 2) || []
  const [pageHeader, setPageHeader] = useState<PageHeaderType | null>(null)

  const { collapsed } = useGlobalQuery()

  useEffect(() => {
    user?.store && setPageHeader({ title: user.store.name })
  }, [])

  useEffect(() => {
    switch (pathContext) {
      case '':
        setPageHeader({
          title: 'Insights',
          tooltipTitle: (
            <span>
              All your insights on this dashboard can be filtered by your
              store's locations and time period.
            </span>
          )
        })
        break
      case 'analytics':
        setPageHeader({
          title: 'Insights',
          tooltipTitle: (
            <span>
              All your insights on this dashboard can be filtered by your
              store's locations and time period.
            </span>
          )
        })
        break
      case 'heat-map':
        setPageHeader({
          title: 'Insights',
          tooltipTitle: (
            <span>
              All your insights on this dashboard can be filtered by your
              store's locations and time period.
            </span>
          )
        })
        break
      case 'location':
        setPageHeader({
          title: 'Locations',
          tooltipTitle: (
            <span>
              An{' '}
              <a
                href='https://support.slerp.com/en_gb/stores-and-locations-rkkCUtEpd'
                target='_blank'
                rel='noopener noreferrer'
              >
                overview
              </a>{' '}
              of your
              <br />
              stores' set up.
            </span>
          )
        })
        break
      case 'locations':
        setPageHeader({
          title: 'Locations',
          tooltipTitle: (
            <span>
              An{' '}
              <a
                href='https://support.slerp.com/en_gb/stores-and-locations-rkkCUtEpd'
                target='_blank'
                rel='noopener noreferrer'
              >
                overview
              </a>{' '}
              of your
              <br />
              stores' set up.
            </span>
          )
        })
        break
      case 'slerp-menu-manager':
        document.title = 'Slerp Controls - Menu Manager'
        setPageHeader({ title: 'Menu Manager' })
        break
      default:
        setPageHeader(null)
        break
    }
  }, [location.pathname])

  if (pathContext === 'print-order')
    return (
      <Routes>
        <Route path='/print-order/:order_id' element={<PrintOrder />} />
      </Routes>
    )

  return (
    <StyledLayout hasSider collapsed={collapsed}>
      <Sidebar />
      <Layout className='site-layout'>
        <LayoutTitle pageHeader={pageHeader} />
        <LayoutContent>
          <Suspense fallback={<Loading />}>
            {' '}
            <Outlet />
          </Suspense>
          <BackTop />
        </LayoutContent>
      </Layout>
    </StyledLayout>
  )
}

const StyledLayout = styled(Layout)<{ collapsed: boolean }>`
  .ant-btn:not(.ant-btn-icon-only),
  .ant-btn.ant-btn-default:not(.ant-btn-icon-only) {
    display: flex;
    align-items: center;
  }

  .site-layout {
    margin-left: ${({ collapsed }) =>
      collapsed ? `${COLLAPSED_MARGIN_LEFT}px` : `${EXPANDED_MARGIN_LEFT}px`};
    transition: margin-left 0.2s;
  }
`

export default StaffContainer
